<template>
  <div class="container-grey text-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>